module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB2002-f7a6147e63a6170cb00241fa27e5a46c.png";